import { render, staticRenderFns } from "./edit-limit.vue?vue&type=template&id=4414c3b8&scoped=true&"
import script from "./edit-limit.vue?vue&type=script&lang=js&"
export * from "./edit-limit.vue?vue&type=script&lang=js&"
import style0 from "./edit-limit.vue?vue&type=style&index=0&id=4414c3b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4414c3b8",
  null
  
)

export default component.exports